export const auditPayload = (PractitionerID, patientName , type , reason) => {
    return {
      resourceType: "AuditEvent",
      type: {
        code: type?.code, // Code for Creation
        system: "http://terminology.hl7.org/CodeSystem/audit-event-type",
        display: type?.display,
      },
      recorded: new Date().toISOString(),
      agent: [
        {
          requestor: true,
          type: {
            coding: [
              {
                system: "http://terminology.hl7.org/CodeSystem/extra-security-role-type",
                code: "110153", 
              },
              
            ],
          },
          who: {
            reference: PractitionerID, 
          },
        },
      ],
      source: {
        observer: {
          reference:PractitionerID, 
          display: "Device Name", 
        },
      },
      entity: [
        {
          what: {
            identifier: {
              system: "http://example.com/patient-identifier",
              value: patientName, 
            },
            display:reason
          },
        },
      ],
    };
  };